export const shareData = {
  facebook: {
    ariaDesc: 'Share this article on Facebook',
    mainDesc: 'Share on Facebook',
  },
  twitter: {
    ariaDesc: 'Share this article on X',
    mainDesc: 'Share on X',
  },
  x: {
    ariaDesc: 'Share this article on X',
    mainDesc: 'Share on X',
  },
  whatsapp: {
    ariaDesc: 'Send this article to someone using WhatsApp',
    mainDesc: 'Share on Whatsapp',
  },
  mail: {
    ariaDesc: 'Share this article by Email',
    mainDesc: 'Share by email',
  },
  print: {
    ariaDesc: 'Print this article',
    mainDesc: 'Print',
  },
  download: {
    ariaDesc: 'Download this article',
    mainDesc: 'Download',
  },
}
